import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaConsumoLayer from "../components/ListaConsumoLayer";
import { useTranslation } from "../i18n/I18nContext";

const ConsumoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("consumo.breadcrumb.list")} />
      <ListaConsumoLayer />
    </MasterLayout>
  );
};

export default ConsumoPage;
